










































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { debounce } from 'quasar'
import MarkdownEditor from 'components/MarkdownEditor.vue'
import { ForumTopic, StudentGroup } from 'src/graphql/types'

@Component({
  components: {
    MarkdownEditor
  }
})
export default class ForumTopicSettings extends Vue {

  @Prop()
  readonly topic!: ForumTopic

  @Prop()
  readonly groups!: StudentGroup[]

  @Prop()
  readonly selected!: number[]

  created () {
    this.updateInfo = debounce(this.updateInfo, 700)
  }

  updateInfo (info: string) {
    this.$emit('update', { info: info.trim() })
  }
}
